<template>
    <div class="retrievePassword" :class="{'cn':version == 1}">
        <div class="top">
            <!-- <img class="logo" :src="require('../img/top_webLogo.png')"> -->
            <img class="logo" src="../img/login_webLogo.png" v-if="domainName == 'iotena'">
            <img class="logo" :class="{'elinker':domainName == 'elinker'}" src="../img/logo_yl.png" v-if="domainName == 'elinker'">
        </div>
        <div class="content">
          <div class="box">
            <p class="p1">{{$t("App.retrievePassword.text1")}}</p>
            <p class="p2">{{$t("App.retrievePassword.text2")}}</p>
            <el-input
              class="input1"
              :placeholder="$t('App.login.text3')"
              v-model="account">
            </el-input>
            <p class="p2">{{$t("App.retrievePassword.text3")}}</p>
            <div class="input3_box">
              <el-input
                class="input3"
                :placeholder="$t('App.login.text5')"
                v-model="code">
                <!-- <i slot="prefix" class="el-input__icon el-icon-s-goods"></i> -->
              </el-input>
              <div class="img_box" @click="getCodeImage()">
                <img :src="codeImage">
              </div>
            </div>
            <div class="btn_box" @click="getCode()">
              <span>{{$t('App.retrievePassword.text7')}}</span><img src="../img/svg/send_icon.svg">
            </div>
            <p class="p5">{{$t("App.retrievePassword.text4")}}</p>
          </div>
        </div>
        <p class="p4">粤ICP备20011150号-1</p>
        <!-- 获取邮箱验证码 -->
        <!-- :show-close="false" -->
        <el-dialog
          title="Retrieve password"
          :visible.sync="dialogMessage"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="message_dialog"
          width="60rem">
          <el-form ref="formMessage" :model="formMessage" label-width="200px">
            <el-form-item :label="$t('App.retrievePassword.text5')" style="margin-bottom: 20px;" prop="newPassword" :rules="{required: true, message: 'Can not be empty', trigger: 'blur'}">
                <el-input 
                  show-password
                  v-model="formMessage.newPassword" maxlength="6" @keyup.native="messageSaveKeyUp($event)">
                </el-input>
            </el-form-item>

            <el-form-item :label="$t('App.retrievePassword.text6')" prop="emailCode" :rules="{required: true, message: 'Can not be empty', trigger: 'blur'}">
                <el-input v-model="formMessage.emailCode" maxlength="6" @keyup.native="messageSaveKeyUp($event)" >
                    <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
                </el-input>
                <el-button type="primary" @click="getCode()" v-loading="loading.getLoginSms" :disabled="!tiemIntervalIsTrue">
                  <template>{{'Retrieve'}}</template>
                  <template v-if="!tiemIntervalIsTrue">({{tiemInterval}})</template>
                </el-button>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="messageSave()">Confirm</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    import { mapGetters } from 'vuex'
    export default {
        name: 'login',
        data () {
            return {
                account:'',
                eMail:'',
                code:'',
                codeImage:'',

                dialogMessage:false,
                formMessage:{
                    newPassword:'',
                    emailCode:'',
                },
                tiemIntervalIsTrue:true,
                tiemInterval:60,
                tiemIntervalT:null,
                loading:{
                    getLoginSms:false,
                }
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                domainName:'domainName',
            })
        },
        mounted(){
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })
            this.getCodeImage();
        },
        methods:{
            getCodeImage(){
                base.ajax_post(
                    allUrl.login.get_code_image,
                    {
                        type:'1',
                    },
                    {},
                    data=>{
                        this.codeImage = data.data.path;
                    },
                    this
                )
            },
            getCode(){
                base.ajax_post(
                    allUrl.login.getCode,
                    {
                        username:this.account,
                        code:this.code,
                    },
                    {},
                    ()=>{
                        this.dialogMessage = true;
                        this.tiemIntervalFun();
                    },
                    this
                )
            },
            tiemIntervalFun(){
                let this_ = this;
                this.tiemInterval = 60;
                this.tiemIntervalIsTrue = false;
                clearInterval(this.tiemIntervalT)
                this.tiemIntervalT = setInterval(function(){
                    this_.tiemInterval--;
                    if(this_.tiemInterval == 0){
                        this_.tiemIntervalIsTrue = true;
                        clearInterval(this_.tiemIntervalT)
                    }
                },1000)
            },
            messageSaveKeyUp(e){
                if(e.key == 'Enter'){
                  this.messageSave();
                }
            },
            messageSave(){
                base.ajax_post(
                    allUrl.login.chargePassword,
                    {
                        username:this.account,
                        newPassword:this.formMessage.newPassword,
                        emailCode:this.formMessage.emailCode,
                    },
                    {},
                    data =>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.$router.push({path:'/login'});
                        this.$store.commit('ROUTERSTRFUN',{
                            routerStr:'/login',
                        })
                    },
                this)
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .retrievePassword{
        width: 100%;
        height: 100%;
        min-height: 67rem;
        min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        background: #F6F8FA;
        position: relative;
        &.cn{
          .content{
            .btn_box{
              background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
          }
        }
        .top{
          // text-align: center;
          height: 4.17rem;line-height: 4.17rem;
          background: #FFFFFF;
          box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
          display: flex;
          justify-content: center;
          align-items: center;
          .logo{
            height: 1.4rem;
            &.elinker{
              height: 3.4rem;
            }
          }
        }
        .content{
          position: relative;
          width: 77.75rem;height: 51.67rem;
          margin:4.67rem auto 0;
          background: #FFFFFF;
          border: 1px solid #EBEFF2;
          .box{
            width: 42.5rem;
            margin: 0 auto;
          }
          .p1{
            text-align: center;
            margin: 4.67rem 0 4.08rem 0;
            font-family: AlibabaPuHuiTiB;
            font-size: 2.33rem;
            color: #333333;
            letter-spacing: 0;
            text-align: center;
          }
          .p2{
            margin-bottom: 0.83rem;
            font-family: PingFang-SC-Medium;
            font-size: 1rem;
            color: #657085;
            letter-spacing: 0;
          }
          .p3{
            font-family: AlibabaPuHuiTiM;
            font-size: 1.83rem;
            color: #657085;
            letter-spacing: 0;
          }
          .input1,.input2{
            margin-bottom: 2rem;
          }
          .el-input{
            width: 42.5rem;
            .el-input__inner{
              height: 3.33rem;line-height: 3.33rem;
              background: #F6F8FA;
              border-radius: 2px;
              border-radius: 2px;
            }
          }
          .input3_box{
            display: flex;
            .input3{
              width: 31.33rem;
            }
            .img_box{
              background: #F2F2F2;
              border: 1px solid #DDDDDD;
              border-radius: 2px;
              border-radius: 2px;
              margin-left: 0.83rem;
              width: 10.33rem;
              img{
                width: 100%;height: 100%;
              }
            }
          }
          .btn_box{
            margin: 2.5rem 0 0.83rem 0;
            width: 42.5rem;
            height: 3.33rem;line-height: 3.33rem;
            text-align: center;
            background: #05CFAB;
            border: 1px solid #F0F0F0;
            border-radius: 2px;
            cursor: pointer;
            span{
              font-family: PingFang-SC-Medium;
              font-size: 1.17rem;
              color: #FFFFFF;
              letter-spacing: 0;
              text-align: center;
            }
            img{
                margin-left: 1.88rem;
            }
          }
          .flex_box{
            width: 31.67rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn_span{
              font-family: PingFang-SC-Medium;
              font-size: 1rem;
              color: #05CFAB;
              letter-spacing: 0;
              text-align: right;
              line-height: 1.42rem;
              cursor: pointer;
            }
          }
          .p5{
            width: 42.5rem;
            font-family: PingFang-SC-Medium;
            font-size: 1rem;
            color: #A4AEB9;
            letter-spacing: 0;
          }
          .logo_box{
            margin: 4.25rem auto 0;
            width: 10rem;height: 2.42rem;
            background: #05CFAB;
            img{
                width: 100%;height: 100%;
            }
          }
        }
        .p4{
          position: absolute;
          left: 0;
          bottom: 1.08rem;
          width: 100%;
          font-family: PingFang-SC-Medium;
          font-size: 1rem;
          color: #999999;
          letter-spacing: 0;
          text-align: center;
        }

        .message_dialog{
            .el-input{
              width: calc(100% - 150px);
            }
            .el-form-item{
                margin: 0px;
                .el-button{
                    float: right;
                }
            }
            .el-dialog__footer{
                text-align:center;
            }
        }
    }
</style>
